import { useMemo } from "react";
import { useColorScheme } from "@mui/joy/styles";
import { createTheme } from "@mui/material/styles";

export type MaterialGridColorMode = "light" | "dark";

export const materialGridThemeTokens = {
  textPrimary: "var(--joy-palette-text-primary)",
  textSecondary: "var(--joy-palette-text-secondary)",
  backgroundBody: "var(--joy-palette-background-body)",
  backgroundSurface: "var(--joy-palette-background-surface)",
  divider: "var(--joy-palette-divider)",
} as const;

/** Build the Material theme bridge in the active Joy color mode. */
export function createMaterialGridTheme(mode: MaterialGridColorMode) {
  return createTheme({
    palette: { mode },
  });
}

/** Material DataGrid and file controls follow Joy's selected light or dark mode. */
export function useMaterialGridTheme() {
  const { mode, systemMode } = useColorScheme();
  const activeMode: MaterialGridColorMode =
    mode === "dark" || (mode === "system" && systemMode === "dark")
      ? "dark"
      : "light";

  return useMemo(() => createMaterialGridTheme(activeMode), [activeMode]);
}
